import "date-fns";
import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import DateFnsUtils from "@date-io/date-fns";
// import ImageUploader from "react-images-upload";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
// import moment from "moment";
import { errorText } from "./errortext";

const sortThaiDictionary = (list) => {
  const newList = [...list];
  newList.sort((a, b) => a.mastername.localeCompare(b.mastername, "th"));
  return newList;
};

export const Text = ({ error, classes, obj, onChange }) => {
  return (
    <TextField
      label={
        <>
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </>
      }
      onChange={onChange}
      style={{ padding: 8, boxSizing: "border-box" }}
      placeholder={obj.placeholder}
      value={obj.value}
      fullWidth
      margin="normal"
      InputLabelProps={{
        style: {
          padding: 8,
          fontWeight: 800,
          fontSize: 18,
          transform: "none",
          color: "#292726",
        },
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          marginTop: 32,
          marginBottom: 16,
          fontSize: 18,
          color: "#989898",
          borderBottom: "1px solid #dddddd",
        },
      }}
      error={error}
      helperText={
        error ? errorText[obj.name] || `กรุณาระบุ ${obj.placeholder}` : ""
      }
    />
  );
};

export const TextArea = ({ error, classes, obj, onChange }) => {
  return (
    <TextField
      label={
        <>
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </>
      }
      onChange={onChange}
      style={{ padding: 8, boxSizing: "border-box" }}
      placeholder={obj.placeholder}
      value={obj.value}
      fullWidth
      multiline
      minRows={4}
      margin="normal"
      InputLabelProps={{
        style: {
          padding: 8,
          fontWeight: 800,
          fontSize: 18,
          transform: "none",
          color: "#292726",
        },
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          marginTop: 32,
          marginBottom: 16,
          fontSize: 18,
          color: "#989898",
          borderBottom: "1px solid #dddddd",
        },
      }}
      error={error}
      helperText={
        error ? errorText[obj.name] || `กรุณาระบุ ${obj.placeholder}` : ""
      }
    />
  );
};

export const Email = ({ error, classes, obj, onChange }) => {
  return (
    <TextField
      label={
        <>
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </>
      }
      onChange={onChange}
      style={{ padding: 8, boxSizing: "border-box" }}
      placeholder={obj.placeholder}
      value={obj.value}
      fullWidth
      margin="normal"
      type="email"
      InputLabelProps={{
        style: {
          padding: 8,
          fontWeight: 800,
          fontSize: 18,
          transform: "none",
          color: "#292726",
        },
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          marginTop: 32,
          marginBottom: 16,
          fontSize: 18,
          color: "#989898",
          borderBottom: "1px solid #dddddd",
        },
      }}
      error={error}
      helperText={error ? `กรุณาระบุ ${obj.placeholder}` : ""}
    />
  );
};

export const FieldNumber = ({ error, classes, obj, onChange }) => {
  return (
    <TextField
      label={
        <>
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </>
      }
      onChange={(e) => {
        if (e.target.value === "") {
          onChange(e);
          return;
        }
        const value = +e.target.value;
        if (value < 0) {
          return;
        } else {
          onChange(e);
        }
      }}
      style={{ padding: 8, boxSizing: "border-box" }}
      placeholder={obj.placeholder}
      value={obj.value}
      fullWidth
      margin="normal"
      type="number"
      InputLabelProps={{
        style: {
          padding: 8,
          fontWeight: 800,
          fontSize: 18,
          transform: "none",
          color: "#292726",
        },
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          marginTop: 32,
          marginBottom: 16,
          fontSize: 18,
          color: "#989898",
          borderBottom: "1px solid #dddddd",
        },
      }}
      error={error}
      helperText={error ? `กรุณาระบุ ${obj.placeholder}` : ""}
    />
  );
};

export const Date = ({ error, classes, obj, onChange }) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        style={{ padding: 8, boxSizing: "border-box" }}
        fullWidth
        value={obj.value}
        label={
          <>
            {obj.label}
            {!!obj.required && <span className={classes.required}>*</span>}
          </>
        }
        placeholder={obj.placeholder}
        format="dd/MM/yyyy"
        onChange={onChange}
        disableFuture={obj.name === "birthDay"}
        disablePast={obj.name === "work_date"}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        InputLabelProps={{
          style: {
            padding: 8,
            fontWeight: 800,
            fontSize: 18,
            transform: "none",
            color: "#292726",
          },
          shrink: true,
        }}
        InputProps={{
          disableUnderline: true,
          style: {
            marginTop: 32,
            marginBottom: 16,
            fontSize: 16,
            color: "#989898",
            borderBottom: "1px solid #dddddd",
          },
        }}
      />
      {error && (
        <FormHelperText style={{ margin: "0 0 0 8px", color: "#f44336" }}>
          {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
        </FormHelperText>
      )}
    </MuiPickersUtilsProvider>
  );
};

export const List = ({ error, classes, obj, onChange }) => {
  return (
    <div
      style={{
        padding: 8,
        boxSizing: "border-box",
        width: "100%",
        marginTop: 16,
      }}
    >
      <FormControl margin="normal" style={{ width: "100%" }}>
        <div
          style={{
            fontSize: 18,
            marginTop: -16,
            fontWeight: 800,
            lineHeight: "26px",
            color: "#292726",
          }}
        >
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </div>

        <Select
          disableUnderline
          style={{
            fontSize: 18,
            borderBottom: "1px solid #dddddd",
            color: "#989898",
          }}
          value={obj.value}
          onChange={onChange}
        >
          {sortThaiDictionary(obj.list).map((v, k) => (
            <MenuItem
              style={{ whiteSpace: "normal", color: "#292726" }}
              key={k}
              value={obj.select_table === "other" ? v.otherId : v.masterid}
            >
              {v.mastername}
            </MenuItem>
          ))}
        </Select>
        {error && (
          <FormHelperText className={classes.errorText}>
            {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

export const Check = ({ error, classes, obj, onChange, onChangeMore }) => {
  return (
    <FormControl
      margin="normal"
      style={{ padding: 8, boxSizing: "border-box", width: "100%" }}
      component="fieldset"
    >
      <FormLabel
        style={{ fontWeight: 800, color: "#292726", fontSize: 18 }}
        component="legend"
      >
        {obj.label}
        {!!obj.required && <span className={classes.required}>*</span>}
      </FormLabel>
      <FormGroup row style={{ marginTop: 16 }}>
        {sortThaiDictionary(
          obj.list.filter((f) => (!!f.masterid ? f.masterid !== 999999 : true))
        ).map((v, k) => (
          <FormControlLabel
            className={classes.checkBox}
            key={k}
            control={
              <Checkbox
                checked={!!v.checked}
                onChange={onChange}
                name={obj.select_table === "other" ? v.otherId : v.masterid}
                color="primary"
              />
            }
            label={<div style={{ lineHeight: "26px" }}>{v.mastername}</div>}
            style={{ marginTop: 8 }}
          />
        ))}
        {obj.name === "interesting" && (
          <FormControlLabel
            className={classes.checkBox}
            key={999999}
            control={
              <TextField
                onChange={(v) => onChangeMore(v.target.value)}
                style={{ padding: 8, boxSizing: "border-box" }}
                placeholder="อื่น ๆ"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  style: {
                    padding: 8,
                    fontWeight: 800,
                    fontSize: 18,
                    transform: "none",
                    color: "#292726",
                  },
                  shrink: true,
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    width: "90%",
                    marginBottom: 16,
                    fontSize: 18,
                    color: "#989898",
                    borderBottom: "1px solid #dddddd",
                  },
                }}
              />
            }
            style={{ marginTop: 8 }}
          />
        )}
      </FormGroup>
      {error && (
        <FormHelperText className={classes.errorText}>
          {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export const File = ({ error, classes, obj, handleFile }) => {
  return (
    <div className={classes.inputFile}>
      <input
        style={{ display: "none" }}
        accept="application/pdf,image/png, image/jpeg, image/jpg, .doc, .docx"
        id="contained-button-file"
        type="file"
        onChange={(e) => {
          if (e.target.files[0].size >= 3 * 1024 * 1024) {
            alert("ไฟล์ต้องขนาดไม่เกิน 3MB");
          } else {
            handleFile(e.target.files);
          }
          e.target.value = null;
        }}
      />
      <label htmlFor="contained-button-file">
        <Button
          variant="outlined"
          color="primary"
          style={{
            minWidth: 144,
            height: 40,
            fontSize: 18,
            lineHeight: "32px",
            margin: "16px 0 16px 0",
            textTransform: "none",
          }}
          component="span"
        >
          {obj.label}{" "}
          {!!obj.required && <span className={classes.required}> *</span>}
        </Button>
      </label>

      <div style={{ fontSize: 14 }}>
        รองรับนามสกุลไฟล์ .pdf, .jpeg, .png, .jpg, .doc .docx ขนาดไม่เกิน 3MB
      </div>

      {obj.value?.size > 0 && (
        <Alert
          severity="success"
          style={{
            wordBreak: "break-all",
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                handleFile([]);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {obj.value.name || ""}
        </Alert>
      )}

      {error && (
        <FormHelperText className={classes.errorText}>
          {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
        </FormHelperText>
      )}
    </div>
  );
};

export const Image = ({ error, classes, obj, handleUpload }) => {
  const [img, setImg] = useState("");

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      let dataURL = e.target.result;
      dataURL = dataURL.replace(";base64", `;name=${file.name};base64`);
      setImg(dataURL);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className={classes.inputFile}>
      <input
        style={{ display: "none" }}
        accept="image/png, image/gif, image/jpeg, image/jpg"
        id="contained-button-image"
        type="file"
        onChange={(e) => {
          if (e.target.files[0].size >= 2 * 1024 * 1024) {
            alert("ไฟล์ต้องขนาดไม่เกิน 2MB");
          } else {
            handleUpload(e.target.files);
            readFile(e.target.files[0]);
          }
          e.target.value = null;
        }}
      />
      <label htmlFor="contained-button-image">
        <Button
          variant="outlined"
          color="primary"
          style={{
            minWidth: 144,
            height: 40,
            fontSize: 18,
            lineHeight: "32px",
            margin: "16px 0 16px 0",
            textTransform: "none",
          }}
          component="span"
        >
          {obj.label}{" "}
          {!!obj.required && <span className={classes.required}> *</span>}
        </Button>
      </label>

      <div style={{ fontSize: 14 }}>
        รองรับนามสกุลไฟล์ .jpg .png .jpeg เท่านั้น ขนาดไม่เกิน 2MB
      </div>

      {obj.value?.size > 0 && (
        <Alert
          severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                handleUpload([]);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <img
            src={img}
            alt={obj.value.name || ""}
            style={{ border: "solid 10px #dddddd" }}
            width="50%"
          />
        </Alert>
      )}

      {error && (
        <FormHelperText className={classes.errorText}>
          {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
        </FormHelperText>
      )}
    </div>
  );
};

export const ListSearch = ({ error, classes, obj, onChange }) => {
  return (
    <div
      style={{
        padding: 8,
        boxSizing: "border-box",
        width: "100%",
        marginTop: 16,
      }}
    >
      <FormControl margin="normal" style={{ width: "100%" }}>
        <div
          style={{
            fontSize: 18,
            marginTop: -16,
            fontWeight: 800,
            lineHeight: "26px",
            color: "#292726",
          }}
        >
          {obj.label}
          {!!obj.required && <span className={classes.required}>*</span>}
        </div>

        <Autocomplete
          fullWidth
          options={sortThaiDictionary(obj.list)}
          classes={{
            option: classes.option,
          }}
          onChange={(e, n) => {
            if (!!n) {
              onChange(
                e,
                obj.select_table === "other" ? n.otherId : n.masterid
              );
            } else {
              onChange(e, null);
            }
          }}
          autoHighlight
          getOptionLabel={(option) => option.mastername}
          renderOption={(option) => (
            <React.Fragment>{option.mastername}</React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={obj.placeholder}
              label={obj.mastername}
              margin="normal"
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                style: {
                  fontSize: 18,
                  color: "#989898",
                  borderBottom: "1px solid #dddddd",
                },
              }}
            />
          )}
        />

        {error && (
          <FormHelperText className={classes.errorText}>
            {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

// readFile(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     // Read the image via FileReader API and save image result in state.
//     reader.onload = function (e) {
//       // Add the file name to the data URL
//       let dataURL = e.target.result;
//       dataURL = dataURL.replace(";base64", `;name=${file.name};base64`);
//       resolve({file, dataURL});
//     };

//     reader.readAsDataURL(file);
//   });
// }

// export const Image = ({ error, classes, obj, handleUpload }) => {
//   return (
//     <div style={{ margin: 8 }}>
//       <ImageUploader
//         withPreview
//         singleImage
//         buttonText={
//           <span style={{ fontSize: 18 }}>
//             {obj.label}
//             {!!obj.required && <span className={classes.required}> *</span>}
//           </span>
//         }
//         label={
//           <span style={{ fontSize: 14 }}>
//             รองรับนามสกุลไฟล์ .jpg .png .jpeg ขนาดไม่เกิน 10MB
//           </span>
//         }
//         onChange={(f) => handleUpload(f)}
//         imgExtension={[".jpg", ".png", ".jpeg"]}
//         accept={".jpg,.jpeg',.png"}
//         maxFileSize={10485760}
//         fileTypeError="รองรับนามสกุลไฟล์ .jpg .png .jpeg เท่านั้น"
//         fileSizeError="ไฟล์ต้องขนาดไม่เกิน 10MB"
//       />

//       {error && (
//         <FormHelperText className={classes.errorText}>
//           {error ? `กรุณาระบุ ${obj.placeholder}` : ""}
//         </FormHelperText>
//       )}
//     </div>
//   );
// };
